import { z } from 'zod';

export const locationStatus = ['closed', 'open', 'running'] as const;
export const LocationStatusSchema = z.enum(locationStatus);
export type LocationStatus = z.infer<typeof LocationStatusSchema>;

export const locationStatusOptions: { value: LocationStatus; label: string }[] = [
	{ value: 'closed', label: 'Closed' },
	{ value: 'open', label: 'Open' },
	{ value: 'running', label: 'Running' },
];

export const CodeSchema = z
	.string()
	.min(3)
	.transform((val) => val.toUpperCase());
export type Code = z.infer<typeof CodeSchema>;

export const RoomSchema = z.object({
	id: z.uuid(),
	name: z.string(),
	repairTime: z.number().min(10).default(600),
	activationCodes: z.array(CodeSchema).default([]),
	// TODO: bring this back when array field errors are implemented
	//.min(1, 'At least one activation code is required').default(['AAA']),
	repairCodes: z.array(CodeSchema).default([]),
	// TODO: bring this back when array field errors are implemented
	//.min(1, 'At least one repair code is required').default(['AAA']),
});
export type Room = z.infer<typeof RoomSchema>;

export const RoomsUpdateSchema = z.object({
	rooms: z.array(RoomSchema),
});
export type RoomsUpdate = z.infer<typeof RoomsUpdateSchema>;
